export default __webpack_public_path__ + "static/media/search_icon.0a08f664.svg";